export default "__VITE_ASSET__Bw6s1lyd__"